import typeaheadSelectAccountView from './typeaheadSelectAccountComponent.html';
import _ from 'lodash';

export function typeaheadSelectAccountComponent() {
	return {
		bindings: {
			model: '=',
			prependChoices: '<?',
			limit: '<?',
			placeholder: '<?',
			onChoose: '&?',
		},
		controllerAs: 'vm',
		controller: typeaheadSelectAccountComponentCtrl,
		template: typeaheadSelectAccountView,
	};
}

export class typeaheadSelectAccountComponentCtrl {
	constructor($scope, Identity) {
		'ngInject';
		this.$scope = $scope;
		this.Identity = Identity;
	}

	$onInit() {
		if (!this.limit) {
			this.limit = 10;
		}
		if (!this.placeholder) {
			this.placeholder = 'Choose or type...';
		}
		// setup choices
		this.accounts = this.Identity.accountChoices();
		if (this.prependChoices) {
			this.accounts = this.prependChoices.concat(this.accounts);
		}
		this.defaultAccountList = this.accounts.slice(0, this.limit);
		// handle account id changes from parent scope
		this.$scope.$watch('vm.model', newVal => {
			this.chosenAccount = _.find(this.accounts, { id: newVal });
		});
	}

	handleChosen(account) {
		this.model = account.id;
		this.onChoose &&
			this.onChoose({
				$account: {
					id: account.id,
					name: account.$search,
				},
			});
	}
}
